import { Injectable } from '@angular/core';
import { EmailInfo } from '@model/user/email-info';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EmailInfoStorage {
    emailInfo = new BehaviorSubject<EmailInfo>({} as any);
    emailInfoRefresher = new BehaviorSubject<boolean>(false);
    constructor() { }

    setEmailInfo(emailInfo: EmailInfo): void {
        this.emailInfo.next(emailInfo);
    }

    getEmailInfo(): Observable<EmailInfo> {
        return this.emailInfo.asObservable();
    }

    refreshEmailInfo(isUpdate: boolean) {
        this.emailInfoRefresher.next(isUpdate);
    }

    listenEmailInfoRefresher(): Observable<boolean> {
        return this.emailInfoRefresher.asObservable();
    }
}
